<template>
    <div>
        <vx-card class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="w-1/2">
                    <h5 class="mb-4">Device Setup Settings</h5>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">Request Code</div>
                        <div class="table-cell w-3/5 p-4">{{device_assignment.code}}</div>
                    </div>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">Merchant</div>
                        <div class="table-cell w-3/5 p-4">{{device_assignment.merchants.full_name}}</div>
                    </div>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">Merchant Code</div>
                        <div class="table-cell w-3/5 p-4">{{device_assignment.merchants.code}}</div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Description
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            {{device_assignment.notes}}
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Tags
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vue-tags-input id="lnk-tags" v-model="tag" :tags="device_assignment.tags"
                                            @tags-changed="newTags => tags = newTags" disabled/>
                            <span class="text-danger text-sm">{{ errors.first('tags') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Device Type
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-select id="cbo-device-type" class="w-full" placeholder="Device Type" v-validate="'required'"
                                       name="device type" vs-multiple autocomplete
                                       v-model="device_assignment.device_type_id" disabled>
                                <vs-select-item v-bind:id="'cbo-device-type-list-'+index" :key="index" :value="item.id" :text="item.name"
                                                v-for="(item,index) in device_type"/>
                            </vs-select>
                            <span class="text-danger text-sm" v-show="errors.has('device type')">{{ errors.first('device type') }}</span>
                            <span class="text-danger text-sm">{{ errors.first('device type') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">Device Requested &emsp;&emsp;&nbsp;</div>
                        <div class="table-cell w-3/5 p-4">
                            <span class="w-full mb-4 no-icon-border">{{device_assignment.device_qty}}</span>
                        </div>
                    </div>
                </div>

                <div class="hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                    <img class="w-1/2 mx-auto" src="@/assets/images/pages/graphic-4.png" alt="login"/>
                </div>
            </div>
            <div class="w-full flex flex-no-wrap">
                <div class="vx-col sm:w-1/5 w-full p-4">
                    <span>Payment Acceptance</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full p-2">
                    <div class="vx-row">
                        <div class="w-full flex flex-wrap">
                            <div :key="index" v-for="(dt, index) in listOption" class="w-1/2 p-4">
                                <vs-checkbox
                                        v-bind:id="'chk-readonly-payment-channel-'+dt.id"
                                        v-model="paymentChannelsSelected"
                                        :vs-value="dt.id"
                                        disabled
                                >{{ dt.name }}
                                </vs-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-no-wrap" v-if="device_assignment.count_chipbased !== 0">
                <div class="vx-col sm:w-1/5 w-full p-4">
                    <span>Configuration</span>
                </div>
                <div class="vx-col sm:w-3/4 w-full p-2">
                    <div class="vx-row">
                        <div class="w-1/3" v-if="renderComponent">
                            <custom-upload id="fil-configuration" title="Configuration" :file-name="documents[0].file_name"
                                           :on-change-callback="handleFileUpload"
                                           :on-delete-callback="handleDelete"/>
                        </div>
                        <div class="flex flex-no-wrap w-2/4 self-center">
                            <div class="w-1/4 self-center">
                                <vx-tooltip text="Download Sample Configuration Chip Based" position="top">
                                    <vs-button id="btn-download-sample-configuration-chip-based" class="mb-4 md:mb-0" @click="downloadExcel(true)" icon-pack="feather"
                                               icon="icon-credit-card"></vs-button>
                                </vx-tooltip>
                            </div>
                            <div class="w-1/4">&nbsp;</div>
                            <div class="w-1/4 self-center" v-if="device_assignment.count_chipbased === 0">
                                <vx-tooltip text="Download Sample Configuration merchant not select chip based"
                                            position="top">
                                    <vs-button id="btn-download-sample-configuration" class="mb-4 md:mb-0" @click="downloadExcel(false)" icon-pack="feather"
                                               icon="icon-download"></vs-button>
                                </vx-tooltip>
                            </div>

                        </div>
                    </div>
                    <div class="w-full self-center">
                        Please download sample configuration excel and follow our template.<br/>
                    </div>
                </div>
            </div>
        </vx-card>
        <vx-card>
            <file-list :request_id="requestID"></file-list>
        </vx-card>
        <vx-card>
            <div class="w-full text-right">
                <vs-button id="btn-cancel" type="border" @click="backPage">Cancel</vs-button>
                <vs-button id="btn-submit" class="ml-4" @click="submitRequest">Submit</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import FileList from "./DeviceSetupConfigurationFile.vue"
    import DeviceList from "@/views/device/request-device/details/DeviceList.vue";
    import CustomUpload from "@/components/upload/custom-upload";
    import AxiosCall from "@/global/AxiosCall";
    import FileAPI from "@/network/api/FileAPI"
    import Excel from "exceljs/modern.browser"
    import {saveAs} from 'file-saver'
    import {url} from '@/configs/apiUrl'
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
        components: {
            FileList,
            DeviceList,
            VueTagsInput,
            CustomUpload
        },
        data() {
            return {
                requestID: null,
                renderComponent: true,
                dataTrx: [],
                device_assignment: {
                    id: "",
                    code: "",
                    notes: "",
                    tags: [],
                    device_type_id: '',
                    device_qty: '',
                    merchants: {
                        full_name: ''
                    },
                    count_chipbased: 0
                },
                paymentChannels: [],
                paymentChannelsSelected: [],
                listOption: [],
                tag: '',
                device_type: [],
                documents: [
                    {
                        name: "Configuration",
                        file_name: "",
                        url: ""
                    },
                ],
                file: null
            };
        },
        methods: {
            backPage() {
                //this.$router.go(-1);
                this.$router.push('/device/setup')
            },
            submitRequest() {
                if (this.device_assignment.count_chipbased !== 0) {
                    if (this.file == null) {
                        this.$vs.notify({
                            title: "Alert",
                            text: "Merchant Configuration File is Required for This Payment Channel",
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "danger",
                            position: "top-right"
                        })
                        return false
                    }
                }

                this.openLoading()
                if (this.file === null) {
                    this.file = {
                        file: null,
                        data: {
                            id: this.device_assignment.id
                        }
                    }
                }

                FileAPI.UploadDeviceSetupConfig(this.file).then((result) => {
                    this.$vs.loading.close()
                    if (result.code == 200) {
                        this.$store.dispatch('createAuditTrail', {
                            user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu:      "Device Setup Setting",
                            activity: "Add Configuration",
                            data_before: {},
                            data_after: result.data,
                        })
                        let status = true
                        this.$router.push({name: "deviceSetup", params: {status: status}})
                    }
                }).catch(error => {
                    this.$vs.loading.close()
                    this.$vs.notify(error.response.data.notify)
                })

            },
            openLoading() {
                this.$vs.loading({
                    type: 'default',
                })
            },
            handleFileUpload(file) {
                let payload = {
                    file: file,
                    data: {
                        id: this.device_assignment.id
                    }
                }
                this.file = payload

                FileAPI.Upload(payload).then((result) => {
                    this.file.data.details = {
                        attach: {
                            name: file.name,
                            url: result.data.url
                        }
                    }
                }, () => {
                    this.forceRerender()
                })
            },
            handleDelete(file, title) {
                if (title === this.documents[0].name) {
                    this.documents[0].file_name = ""
                    this.documents[0].url = ""
                }

                this.file = null
            },
            toColumnName(num) {
                let ret = ''
                for (let a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
                    ret = String.fromCharCode(parseInt((num % b) / a) + 65) + ret;
                }
                return ret;
            },
            downloadItem() {
                AxiosCall.DownloadExcel(this.documents[0].url, {name: this.documents[0].file_name})
            },
            sortObject(object) {
                var sortedObj = {},
                    keys = Object.keys(object);

                keys.sort(function (key1, key2) {
                    key1 = key1.toLowerCase(), key2 = key2.toLowerCase();
                    if (key1 < key2) return -1;
                    if (key1 > key2) return 1;
                    return 0;
                });

                for (var index in keys) {
                    var key = keys[index];
                    if (typeof object[key] == 'object' && !(object[key] instanceof Array)) {
                        sortedObj[key] = this.sortObject(object[key]);
                    } else {
                        sortedObj[key] = object[key];
                    }
                }

                return sortedObj;
            },
            downloadExcel(chipbased) {
                console.log("Is chipbased: ", chipbased)
                let workbook = new Excel.Workbook();
                workbook.creator = JSON.parse(localStorage.getItem("userInfo")).displayName;
                workbook.lastModifiedBy = JSON.parse(localStorage.getItem("userInfo")).displayName;
                workbook.created = new Date();
                workbook.modified = new Date();
                workbook.lastPrinted = new Date();

                workbook.properties.date1904 = true;
                let sheet = workbook.addWorksheet('Sheet1', {properties: {tabColor: {argb: 'FFC0000'}}});
                let sheetRef = workbook.addWorksheet('Payment channel reference', {properties: {tabColor: {argb: 'FFC0000'}}});
                let font = {name: 'Consolas', size: 10};
                let row = 5

                sheet.getCell('A2').value = 'device code'
                sheet.getCell('A3').value = 'sample device code'
                sheet.getCell('B2').value = 'device name'
                sheet.getCell('B3').value = 'sample device name'
                sheet.getCell('C2').value = 'config profiles'
                sheet.getCell('C3').value = '{"sample1": 101, "sample2": 202, "sample3": "303"}'

                for (let i = 1; i <= 60; i++) {
                    for (let a = 1; a <= row; a++) {
                        sheet.getCell(this.toColumnName(i) + "" + a).font = font
                    }
                }

                sheetRef.getCell('A1').value = 'Payment channel yang tersedia'
                sheetRef.getCell('A2').value = 'CHANNEL ID'
                sheetRef.getCell('B2').value = 'CHANNEL CODE'
                sheetRef.getCell('C2').value = 'CHANNEL NAME'
                for (let i = 0; i < this.paymentChannels.length; i++) {
                    sheetRef.getCell('A' + (i + 3)).value = this.paymentChannels[i].id
                    sheetRef.getCell('B' + (i + 3)).value = this.paymentChannels[i].code
                    sheetRef.getCell('C' + (i + 3)).value = this.paymentChannels[i].name
                }

                let startRow = 1
                let startColumn = 4;

                let configChannelSelected = []
                let payment_method_show = ['chipbase', 'closeloop', 'cash']
                for (let dt of this.listOption) {
                    if (this.paymentChannelsSelected.includes(dt.id) && payment_method_show.includes(dt.payment_methods.code)){
                        let result = {}
                        result["channel id"] = dt.id
                        result["channel code"] = dt.code
                        result["channel name"] = dt.name
                        result.property = []
                        result.sample = []

                        if (dt.general_configs.length >0){
                            result.property = dt.general_configs[0].value.data_header
                            result.sample = dt.general_configs[0].value.data_value
                        }

                        configChannelSelected.push(result)
                    }
                }

                let columnIssuer = startColumn
                let propertyColumns = []
                let sampleDatas = []
                for (let key_channel in configChannelSelected) {
                    sheet.getCell(this.toColumnName(columnIssuer) + startRow).value = configChannelSelected[key_channel]["channel code"]
                    columnIssuer += configChannelSelected[key_channel].property.length
                    let properties = configChannelSelected[key_channel].property
                    let samples = configChannelSelected[key_channel].sample[0]
                    for (let i in properties) {
                        propertyColumns.push(properties[i])
                        if (samples[properties[i]] != undefined) {
                            if (properties[i] === "channel id" || properties[i] === "channel code" || properties[i] === "channel name") {
                                if (properties[i] === "channel id") sampleDatas.push(configChannelSelected[key_channel]["channel id"])
                                if (properties[i] === "channel code") sampleDatas.push(configChannelSelected[key_channel]["channel code"])
                                if (properties[i] === "channel name") sampleDatas.push(configChannelSelected[key_channel]["channel name"])
                            } else {
                                sampleDatas.push(samples[properties[i]])
                            }
                        } else {
                            sampleDatas.push("nodata")
                        }
                    }
                }
               
                let columnIssuerProperty = startColumn
                for (let key in propertyColumns) {
                    sheet.getCell(this.toColumnName(columnIssuerProperty) + 2).value = propertyColumns[key]
                    columnIssuerProperty++
                }

                let columnIssuerData = startColumn
                for (let key in sampleDatas) {
                    sheet.getCell(this.toColumnName(columnIssuerData) + 3).value = sampleDatas[key]
                    columnIssuerData++
                }

                workbook.xlsx.writeBuffer().then((buf) => {
                    saveAs(new Blob([buf]), `sample_device_configuration.xlsx`);
                });
            }
        },
        forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;
            this.$nextTick(() => {
                // Add the component back in
                this.renderComponent = true;
            });
        },
        mounted() {
            this.requestID = parseInt(this.$route.query.id)

            AxiosCall.Get(url.svd.device_type.selection).then(response => {
                if (response.code == 200) {
                    this.device_type = response.data;
                } else {
                    this.warning("Get device type", "Fail get device type");
                }
            }).catch(() => {
            });

            AxiosCall.Get(url.svd.payment_channel.list_selection).then(response => {
                if (response.code == 200) {
                    this.listOption = response.data;
                }
            });

            AxiosCall.Get(url.svd.device_setup.list + "/" + this.$route.query.id).then(response => {
                this.device_assignment = response.data[0]
                this.device_assignment.count_chipbased = parseInt(response.data[0].count_chipbased)
                this.device_assignment.tags = []
                this.paymentChannels = response.data[0].merchants.channels
                if (response.data[0].details !== null && response.data[0].details !== undefined) {
                    this.documents[0].file_name = response.data[0].details.attach.name
                    this.documents[0].url = url.content_delivery_url + '' + response.data[0].details.attach.url
                }

                for (let i in response.data[0].tag) {
                    this.device_assignment.tags.push({text: response.data[0].tag[i]})
                }

                for (let i in this.paymentChannels) {
                    this.paymentChannelsSelected.push(
                        this.paymentChannels[i].id
                    );
                }
            })
        }
    };
</script>

<style lang="scss">
    .con-input-upload {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 73px;
        text-align: left;
        margin: 0px;
        flex-direction: column;

        .text-input {
            text-align: left;
            width: 80%;
            display: block;
        }

        .vs-upload--button-upload {
            text-align: right;
            width: 20%;
            display: block;
            right: 0;
            bottom: auto;
            margin-right: 10px;
        }
    }

    .centerx {
        display: -webkit-box;
        display: -ms-flexbox;
        margin-right: 5px;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
</style>